/**
 * 等高线按离地高度抽稀：近处用成品自身间距，拉高后换大间距，再高则隐藏。
 * interval=0 表示隐藏。
 */
export const DEFAULT_CONTOUR_LOD = {
  enabled: true,
  steps: [
    { aboveMeters: 1500, interval: 50 },
    { aboveMeters: 3000, interval: 100 },
    { aboveMeters: 8000, interval: 0 }
  ]
};

export function normalizeContourLodSettings(raw) {
  let obj = raw;
  if (typeof raw === 'string') {
    try {
      obj = JSON.parse(raw);
    } catch (_) {
      obj = null;
    }
  }
  const enabled = obj == null
    ? true
    : !(obj.enabled === false || obj.enabled === 'false' || obj.enabled === 0);
  const src = Array.isArray(obj?.steps) && obj.steps.length
    ? obj.steps
    : DEFAULT_CONTOUR_LOD.steps;
  const steps = src
    .map((s) => ({
      aboveMeters: Math.max(0, Math.round(Number(s?.aboveMeters) || 0)),
      interval: Math.max(0, Math.round(Number(s?.interval) || 0))
    }))
    .filter((s) => Number.isFinite(s.aboveMeters));
  steps.sort((a, b) => a.aboveMeters - b.aboveMeters);
  return {
    enabled,
    steps: steps.length ? steps : DEFAULT_CONTOUR_LOD.steps.map((s) => ({ ...s }))
  };
}

/**
 * @returns {{ mode: 'base' } | { mode: 'hide' } | { mode: 'interval', interval: number }}
 */
export function resolveContourLodForHeight(heightMeters, lodSettings) {
  const cfg = normalizeContourLodSettings(lodSettings);
  if (!cfg.enabled) return { mode: 'base' };
  const h = Number(heightMeters);
  if (!Number.isFinite(h)) return { mode: 'base' };
  const steps = [...cfg.steps].sort((a, b) => b.aboveMeters - a.aboveMeters);
  for (let i = 0; i < steps.length; i += 1) {
    const step = steps[i];
    if (h >= step.aboveMeters) {
      if (step.interval <= 0) return { mode: 'hide' };
      return { mode: 'interval', interval: step.interval };
    }
  }
  return { mode: 'base' };
}
